export const SSO_LOGIN_CONSTANTS = {
  RELOAD: 'RELOAD',
  HEADING1: 'Welcome To DataFlow Foundation Training',
  SUB_HEADING: 'Please continue to sign in using your account.',
  SIGN_IN: 'Sign In'
};

export const SSO_LOGIN_ERROR_CONSTANTS = {
  Not_Authorized: 'Not Authorized .',
  error: 'error'
};
